// frontend/src/site/theme/siteModel.js
// ✅ Contrato leve do que é "editável" por modelo (conteúdo + regras)
// ETAPA 03: padroniza shape e defaults.

export const FEATURED_LIMIT_DEFAULT = 6;

export const SITE_MODEL_DEFAULTS = {
  corretor: {
    modelId: 'corretor',
    featured: {
      enabled: true,
      limit: FEATURED_LIMIT_DEFAULT,
      strategy: 'manual_or_fallback', // se ids tiverem algo -> usa; senão -> recentes
    },
    terrenos: {
      enabled: false,
      limit: FEATURED_LIMIT_DEFAULT,
      strategy: 'latest',
    },
  },

  imobiliaria: {
    modelId: 'imobiliaria',
    featured: {
      enabled: true,
      limit: FEATURED_LIMIT_DEFAULT,
      strategy: 'manual_or_fallback', // ✅ regra que você definiu
    },
    terrenos: {
      enabled: true,
      limit: FEATURED_LIMIT_DEFAULT, // ✅ “últimos 6”
      strategy: 'latest',
    },
  },
};

export function resolveModelId(modelId) {
  const k = String(modelId || '')
    .trim()
    .toLowerCase();
  return SITE_MODEL_DEFAULTS[k] ? k : 'corretor';
}

export function getModelDefaults(modelId) {
  return SITE_MODEL_DEFAULTS[resolveModelId(modelId)];
}
